export default "__VITE_ASSET__fb5bacae__"